/** Register the owned application shell after the page is usable. */
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  if (import.meta.env.DEV) {
    // A production worker previously installed on this localhost origin keeps
    // controlling Vite even though development no longer registers one. Remove
    // only EAX FUEL's worker and caches so an old shell cannot flash before HMR.
    const registrations = navigator.serviceWorker.getRegistrations?.();
    if (registrations) void registrations.then((items) => Promise.all(items
      .filter((registration) => [registration.active, registration.waiting, registration.installing]
        .some((worker) => worker?.scriptURL && new URL(worker.scriptURL).pathname === '/sw.js'))
      .map((registration) => registration.unregister()))).catch(() => {});
    const cacheKeys = globalThis.caches?.keys?.();
    if (cacheKeys) void cacheKeys.then((keys) => Promise.all(keys
      .filter((key) => key.startsWith('eax-fuel-shell-'))
      .map((key) => globalThis.caches.delete(key)))).catch(() => {});
    return;
  }
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      window.dispatchEvent(new CustomEvent('eaxfuel:service-worker-error', { detail: { message: error.message } }));
    });
  }, { once: true });
}
